import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase/app'
import "firebase/auth";
import { db } from "../db";
import router from '../router'
var moment = require('moment');

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoggedIn: false,
    events: []
  },
  mutations: {
    login(state) {
      state.isLoggedIn = true;
    },
    logout(state) {
      state.isLoggedIn = false;
    },
    setEvents(state, events) {
      state.events = events;
    }
  },
  actions: {
    login({ commit }, credentials) {
      return new Promise((resolve, reject) => {
        firebase.auth()
          .signInWithEmailAndPassword(credentials.email, credentials.password)
          .then(() => {
            commit('login')
            resolve();
          })
          .catch(() => {
            reject();
          })
      })
    },
    logout({ commit }) {
      firebase.auth().signOut().then(() => {
        commit('logout');
        router.push({ path: '/login' })
      })
    },
    getEvents({ commit }) {
      return new Promise((resolve, reject) => {
        const today = firebase.firestore.Timestamp.fromDate(new Date());
        db.collection('events').where("startDate", ">", today).get()
          .then(res => {
            const events = res.docs.map(event => {
              return {
                name: event.data().name,
                address: event.data().address,
                startDate: event.data().startDate ? moment(event.data().startDate.toDate()).format('MM/DD/YYYY') : '',
                endDate: event.data().endDate ? moment(event.data().endDate.toDate()).format('MM/DD/YYYY') : '',
                id: event.id
              }
            });
            commit('setEvents', events);
            resolve();
          })
      })
    },
    updateEvent({ dispatch }, event) {
      event.startDate = new Date(event.startDate);
      event.endDate = new Date(event.endDate);
      return new Promise((resolve, reject) => {
        db.collection('events').doc(event.id).set({
          startDate: event.startDate,
          endDate: event.endDate
        }, { merge: true })
          .then(() => {
            return dispatch('getEvents')
          })
          .then(() => {
            resolve();
          }).catch((er) => {
            reject(er);
          })
      })
    }
  },
  modules: {
  }
})
